import Select, { MultiValue, SingleValue } from 'react-select';
import { SelectOptionType } from '@/components/element/Form/SelectOptionType';
import { useEffect, useState } from 'react';

type Props = {
  options?: SelectOptionType[];
  selectedId?: number;
  onChange: (d: SingleValue<SelectOptionType>) => void;
  error?: boolean;
  disabled?: boolean;
  className?: string;
};

export const SelectSingle = ({ options, selectedId, onChange, error, disabled = false, className = '' }: Props) => {
  const [selected, setSelected] = useState<SelectOptionType | null>();

  useEffect(() => {
    if (options) {
      if (selectedId != null) {
        setSelected(options.find((option) => option.value == selectedId) || null);
      } else {
        setSelected((_) => null);
      }
    }
  }, [options, selectedId]);

  const _onChange = (d: SingleValue<SelectOptionType>) => {
    setSelected(d || null);
    onChange(d);
  };

  return (
    <Select
      isDisabled={disabled}
      options={options}
      onChange={_onChange}
      value={selected}
      isClearable={true}
      className={className}
      classNamePrefix="react-select"
      placeholder="選択して下さい"
      theme={(theme) => ({
        ...theme,
        borderRadius: 3,
        colors: {
          ...theme.colors,
          primary25: '#e9aede',
          primary: '#e9aede',
        },
      })}
      classNames={{
        control: (state) => (state.isFocused ? 'focused' : ''),
      }}
      styles={{
        control: (baseStyles, state) => ({
          ...baseStyles,
          borderRadius: '0.5rem',
          borderColor: 'rgba(0, 0, 0, 0.125)',
          borderTopRightRadius: '0.5rem !important',
          borderBottomRightRadius: '0.5rem !important',
          borderLeftWidth: 1,
          padding: 1,
          fontSize: '0.875rem',
          fontWeight: 400,
          lineHeight: '1.4rem',
          border: error ? '1px solid #fd5c70' : '1px solid #d2d6da',
          transition: 'box-shadow 0.15s ease, border-color 0.15s ease',
          boxShadow: error ? '0 0 0 0px rgba(253, 92, 112, 0.6)' : state.isFocused ? '0 0 0 2px #e9aede' : '',
          '&:hover': {
            borderColor: '1',
          },
        }),
        singleValue: (baseStyles) => ({
          ...baseStyles,
          color: '#495057',
        }),
      }}
    />
  );
};
